import styled from "styled-components";
export const TextContainer = styled.p`
  width: 100%;
  margin: 1.1rem 0;
  text-align: start;
  word-break: break-word;
  white-space: pre-line;
  overflow-wrap: break-word;
  -ms-word-break: break-word;
  word-break: break-word;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
`;
